// extracted by mini-css-extract-plugin
export default {"container":"admin-lab-string-quartets_container__+Yi8S"};